import { request } from '@umijs/max';
import { RequestType } from '@/interface';
import {
  bindHouseParamsType,
  floorType,
  roomType,
  unitType,
} from '@/pages/BindHouse/interface';

export const queryBindHouse = async (data: bindHouseParamsType) => {
  return request('/api/property/api/senke/Wxchat/binding/room', {
    method: 'POST',
    data,
  });
};

/**
 * @desc 查询绑定小区
 * @param communityId
 */
export const queryRoom = async (communityId: string) => {
  return request(`/api/property/api/senke/Wxchat/query/room/${communityId}`);
};

/**
 * @desc 查询楼栋列表
 * @param data
 */
export const queryFloorList = async (data: any) => {
  return request<Promise<RequestType<Array<floorType>>>>(
    '/api/property/room/administration/floor/getList',
    {
      method: 'POST',
      data,
    },
  );
};
/**
 * @desc 查询单元列表
 * @param data
 */
export const queryUnitList = async (data: any) => {
  return request<Promise<RequestType<Array<unitType>>>>(
    '/api/property/room/administration/unit/getList',
    {
      method: 'POST',
      data,
    },
  );
};

/**
 * @desc 查询房屋列表
 * @param data
 */
export const queryAllHouseList = async (data: any) => {
  return request<Promise<RequestType<Array<roomType>>>>(
    '/api/property/room/administration/room/queryList',
    {
      method: 'POST',
      data,
    },
  );
};

/**
 * @desc 查询业主信息
 * @param id
 */
export const queryOwnerInfo = async (id: string) => {
  return request<Promise<RequestType<any>>>(
    `/api/property/owner/getOwnerBase/${id}`,
  );
};
